import { useState, useEffect } from "react";
import api from "../services/api";

const MESES_FULL = ["", "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
const ANOS = [2024, 2025, 2026, 2027, 2028];

async function baixar(url, filename) {
  const { data } = await api.get(url, { responseType: "blob" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(data);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}

export default function Relatorios() {
  const [vendedores, setVendedores] = useState([]);
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  const [anoAnual, setAnoAnual] = useState(new Date().getFullYear());
  const [vendedorAnual, setVendedorAnual] = useState("");
  const [anoMensal, setAnoMensal] = useState(new Date().getFullYear());
  const [mesMensal, setMesMensal] = useState(new Date().getMonth() + 1);
  const [vendedorMensal, setVendedorMensal] = useState("");

  useEffect(() => {
    api.get("/vendedores").then(({ data }) => setVendedores(data));
  }, []);

  const nomeV = (id) => vendedores.find((v) => v.id === id)?.nome || "vendedor";

  const run = async (key, fn) => {
    setLoading(key); setError("");
    try { await fn(); }
    catch { setError("Erro ao gerar o relatório. Verifique se existem cálculos para o período selecionado."); }
    finally { setLoading(""); }
  };

  const anualTodosExcel = () => run("atx", () => baixar(`/relatorios/exportar/excel?ano=${anoAnual}`, `relatorio_todos_${anoAnual}.xlsx`));
  const anualTodosPdf  = () => run("atp", () => baixar(`/relatorios/exportar/pdf?ano=${anoAnual}`, `relatorio_todos_${anoAnual}.pdf`));
  const anualIndExcel  = () => { if (!vendedorAnual) { setError("Selecione um vendedor."); return; } run("aix", () => baixar(`/relatorios/exportar/simples?vendedor_id=${vendedorAnual}&ano=${anoAnual}`, `comissoes_${nomeV(vendedorAnual).replace(/ /g,"_")}_${anoAnual}.xlsx`)); };
  const anualIndPdf    = () => { if (!vendedorAnual) { setError("Selecione um vendedor."); return; } run("aip", () => baixar(`/relatorios/exportar/simples-pdf?vendedor_id=${vendedorAnual}&ano=${anoAnual}`, `comissoes_${nomeV(vendedorAnual).replace(/ /g,"_")}_${anoAnual}.pdf`)); };
  const mensalTodosExcel = () => run("mtx", () => baixar(`/relatorios/exportar/mensal-todos-excel?mes=${mesMensal}&ano=${anoMensal}`, `relatorio_todos_${String(mesMensal).padStart(2,"0")}_${anoMensal}.xlsx`));
  const mensalTodosPdf   = () => run("mtp", () => baixar(`/relatorios/exportar/mensal-todos-pdf?mes=${mesMensal}&ano=${anoMensal}`, `relatorio_todos_${String(mesMensal).padStart(2,"0")}_${anoMensal}.pdf`));
  const mensalIndExcel   = () => { if (!vendedorMensal) { setError("Selecione um vendedor."); return; } run("mix", () => baixar(`/relatorios/exportar/mensal?vendedor_id=${vendedorMensal}&mes=${mesMensal}&ano=${anoMensal}`, `relatorio_${nomeV(vendedorMensal).replace(/ /g,"_")}_${String(mesMensal).padStart(2,"0")}_${anoMensal}.xlsx`)); };
  const mensalIndPdf     = () => { if (!vendedorMensal) { setError("Selecione um vendedor."); return; } run("mip", () => baixar(`/relatorios/exportar/mensal-pdf?vendedor_id=${vendedorMensal}&mes=${mesMensal}&ano=${anoMensal}`, `relatorio_${nomeV(vendedorMensal).replace(/ /g,"_")}_${String(mesMensal).padStart(2,"0")}_${anoMensal}.pdf`)); };

  const Btn = ({ k, label, onClick, color = "success", disabled = false }) => (
    <button className={`btn btn-${color} me-2 mb-1`} onClick={onClick} disabled={!!loading || disabled}>
      {loading === k ? <><span className="spinner-border spinner-border-sm me-1"/>Gerando...</> : label}
    </button>
  );

  return (
    <div>
      <h4 className="fw-bold mb-4">Relatórios</h4>
      {error && <div className="alert alert-danger py-2 alert-dismissible">{error}<button type="button" className="btn-close" onClick={() => setError("")}/></div>}

      <div className="card mb-4">
        <div className="card-header fw-semibold bg-primary text-white fs-6">📅 Relatório Anual</div>
        <div className="card-body">
          <div className="mb-3">
            <label className="form-label fw-semibold small">Ano</label>
            <select className="form-select w-auto" value={anoAnual} onChange={(e) => setAnoAnual(Number(e.target.value))}>
              {ANOS.map((y) => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <div className="border rounded p-3 mb-3 bg-light">
            <div className="fw-semibold mb-2 small text-uppercase text-muted">Todos os vendedores</div>
            <Btn k="atx" label="📊 Excel" onClick={anualTodosExcel} color="success"/>
            <Btn k="atp" label="📄 PDF" onClick={anualTodosPdf} color="danger"/>
            <div className="text-muted small mt-1">Relatório gerencial completo: comissão, prêmio, produtividade, encargos, resultado.</div>
          </div>
          <div className="border rounded p-3 bg-light">
            <div className="fw-semibold mb-2 small text-uppercase text-muted">Vendedor específico</div>
            <div className="row g-2 align-items-end">
              <div className="col-md-4">
                <select className="form-select" value={vendedorAnual} onChange={(e) => setVendedorAnual(e.target.value)}>
                  <option value="">— Selecione o vendedor —</option>
                  {vendedores.map((v) => <option key={v.id} value={v.id}>{v.nome}</option>)}
                </select>
              </div>
              <div className="col-auto">
                <Btn k="aix" label="📊 Excel" onClick={anualIndExcel} color="success" disabled={!vendedorAnual}/>
                <Btn k="aip" label="📄 PDF" onClick={anualIndPdf} color="danger" disabled={!vendedorAnual}/>
              </div>
            </div>
            <div className="text-muted small mt-1">Salário Fixo / Comissão Auferida / Valores pagos / Total a Receber.</div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header fw-semibold bg-success text-white fs-6">📆 Relatório Mensal</div>
        <div className="card-body">
          <div className="row g-3 mb-3 align-items-end">
            <div className="col-auto">
              <label className="form-label fw-semibold small">Mês</label>
              <select className="form-select" value={mesMensal} onChange={(e) => setMesMensal(Number(e.target.value))}>
                {MESES_FULL.slice(1).map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
              </select>
            </div>
            <div className="col-auto">
              <label className="form-label fw-semibold small">Ano</label>
              <select className="form-select" value={anoMensal} onChange={(e) => setAnoMensal(Number(e.target.value))}>
                {ANOS.map((y) => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>
          </div>
          <div className="border rounded p-3 mb-3 bg-light">
            <div className="fw-semibold mb-2 small text-uppercase text-muted">Todos os vendedores</div>
            <Btn k="mtx" label="📊 Excel" onClick={mensalTodosExcel} color="success"/>
            <Btn k="mtp" label="📄 PDF" onClick={mensalTodosPdf} color="danger"/>
            <div className="text-muted small mt-1">Um relatório por vendedor — Excel com abas separadas, PDF com páginas separadas.</div>
          </div>
          <div className="border rounded p-3 bg-light">
            <div className="fw-semibold mb-2 small text-uppercase text-muted">Vendedor específico</div>
            <div className="row g-2 align-items-end">
              <div className="col-md-4">
                <select className="form-select" value={vendedorMensal} onChange={(e) => setVendedorMensal(e.target.value)}>
                  <option value="">— Selecione o vendedor —</option>
                  {vendedores.map((v) => <option key={v.id} value={v.id}>{v.nome}</option>)}
                </select>
              </div>
              <div className="col-auto">
                <Btn k="mix" label="📊 Excel" onClick={mensalIndExcel} color="success" disabled={!vendedorMensal}/>
                <Btn k="mip" label="📄 PDF" onClick={mensalIndPdf} color="danger" disabled={!vendedorMensal}/>
              </div>
            </div>
            <div className="text-muted small mt-1">Formato padrão: IDENTIFICAÇÃO / PRODUÇÃO / REMUNERAÇÃO / ENCARGOS / RESULTADO.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
